import axios from "../../../services/axios-config";

export async function restoreCompany({ companyId }) {
    const res = await axios.post(`/admin/companies/${companyId}/restore`);
    return res?.data;
}
